module.exports = __webpack_public_path__ + "7809d6059431eeb3cc9dd31491974ee4.jpg";